import { Card } from '@/components/ui/card';
import type { MapLocation } from '@/entities/dashboard';
import { LucideIcon } from 'lucide-react';
import { LocationItem } from './location-item';

interface LocationsOverviewProps {
  locations: MapLocation[];
  getLocationIcon: (type: string) => LucideIcon;
  getLocationTypeColor: (type: string) => string;
}

export function LocationsOverview({ locations, getLocationIcon, getLocationTypeColor }: LocationsOverviewProps) {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Locations Overview</h3>
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {locations.map((location) => (
          <LocationItem
            key={location.id}
            location={location}
            getIcon={getLocationIcon}
            getColor={getLocationTypeColor}
          />
        ))}
      </div>
    </Card>
  );
}
